import { ReturnStatus } from "@redotech/redo-return-core-common/return-status";

export function getAverageProcessingTimeLabel(
  averageProcessingDays: number,
  completedReturnCount: number,
): string | null {
  if (
    completedReturnCount <= 0 ||
    averageProcessingDays < 4 ||
    !Number.isFinite(averageProcessingDays)
  ) {
    return null;
  }

  return `${averageProcessingDays} days`;
}

export function isReturnProcessingAutomationEnabled(
  returnProcessingAutomation?: ReturnProcessingAutomationConfiguration,
): boolean {
  if (!returnProcessingAutomation?.enabled) {
    return false;
  }

  return [
    returnProcessingAutomation.exchanges,
    returnProcessingAutomation.refunds,
    returnProcessingAutomation.storeCredit,
  ].some(
    (processingStatus) =>
      processingStatus !== undefined &&
      processingStatus !== ReturnStatus.COMPLETE,
  );
}

interface ReturnProcessingAutomationConfiguration {
  enabled?: boolean;
  exchanges?: ReturnStatus;
  refunds?: ReturnStatus;
  storeCredit?: ReturnStatus;
}
